module.exports = __webpack_public_path__ + "media/images/pic/saska/team/teachers/anna-dabrowska-e30dff2ab87c6a4db02f6614a3424b03.webp";